import React from 'react';
import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';
import VocabularyThumbnail from './vocabularyThumbnail';

const VocabularyClipboardModal = ({
  isOpen,
  setShowClipboardModal,
  selectedVocabularies,
  setSelectedVocabularies,
  setDateBasedKey,
  onRemove
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setShowClipboardModal(false)}
      titleName='Currently Selected Vocabularies'
      contentWidth='60%'>
      {selectedVocabularies.length > 0 && <div className='questionsGrid'>
        {selectedVocabularies.map((vocabulary, index) => {
          return (<VocabularyThumbnail key={`${vocabulary.questionId}-${index}`}
            vocabulary={vocabulary}
            selectedVocabularies={selectedVocabularies}
            setSelectedVocabularies={setSelectedVocabularies}
            removeOnly={true}
            setDateBasedKey={setDateBasedKey}
            onRemove={onRemove}
          />);
        })}
      </div>}
    </Modal>
  );
};

VocabularyClipboardModal.propTypes = {
  isOpen: PropTypes.bool,
  setShowClipboardModal: PropTypes.func,
  selectedVocabularies: PropTypes.array,
  setSelectedVocabularies: PropTypes.func,
  setDateBasedKey: PropTypes.func,
  onRemove: PropTypes.func
};

export default VocabularyClipboardModal;
